import Seo from "@/components/common/Seo";
import PageHeader from "@/components/common/PageHeader";
import CTASection from "@/components/common/CTASection";
import { BRAND } from "@/data/content";

const CONTENT = {
  privacy: {
    overline: "Legal",
    title: ["Privacy", "Policy"],
    sections: [
      ["Overview", `${BRAND.name} ("we", "us") respects your privacy. This policy explains how we collect, use and protect the information you share through this website.`],
      ["Information we collect", "We collect the details you provide via our contact and strategy-session forms, such as your name, email, company, role and message, along with basic analytics about how the site is used."],
      ["How we use it", "We use your information solely to respond to enquiries, arrange sessions, send resources you request and improve our services. We never sell your data."],
      ["Data retention", "We retain enquiry data only as long as necessary to serve you and meet our legal obligations, after which it is securely deleted."],
      ["Your rights", "You may request access to, correction of, or deletion of your personal data at any time by contacting us at " + BRAND.email + "."],
      ["Security", "We apply appropriate technical and organisational measures to protect your information against unauthorised access, loss or misuse."],
      ["Contact", `For any privacy questions, email ${BRAND.email}.`],
    ],
  },
  terms: {
    overline: "Legal",
    title: ["Terms of", "Service"],
    sections: [
      ["Acceptance", `By accessing this website you agree to these terms. If you do not agree, please do not use the site.`],
      ["Use of content", "All content is provided for general information about our advisory services. It does not constitute professional, legal or financial advice for your specific situation."],
      ["Intellectual property", `All materials on this site are owned by ${BRAND.name} unless otherwise stated, and may not be reproduced without permission.`],
      ["Engagements", "Any advisory engagement is governed by a separate written agreement. Nothing on this website creates a contractual relationship."],
      ["Limitation of liability", "We make no warranties regarding the completeness or accuracy of website content and are not liable for decisions made in reliance on it."],
      ["Changes", "We may update these terms from time to time. Continued use of the site constitutes acceptance of the current terms."],
      ["Contact", `Questions about these terms can be sent to ${BRAND.email}.`],
    ],
  },
};

export default function Legal({ variant = "privacy" }) {
  const data = CONTENT[variant];
  return (
    <>
      <Seo
        title={variant === "privacy" ? "Privacy Policy" : "Terms of Service"}
        description={variant === "privacy"
          ? `Privacy policy for ${BRAND.name}, Executive Technology Advisor and Fractional CIO.`
          : `Terms of service for ${BRAND.name}, Executive Technology Advisor and Fractional CIO.`}
        path={`/${variant}`}
        keywords={["Executive Technology Advisor", "Fractional CIO"]}
      />
      <PageHeader overline={data.overline} titleLines={data.title} testId={`${variant}-header`} />
      <section data-testid={`${variant}-content`} className="bg-white py-24 md:py-28">
        <div className="mx-auto max-w-3xl space-y-12 px-6 md:px-12">
          {data.sections.map(([h, b], i) => (
            <div key={i}>
              <h2 className="font-heading text-2xl font-bold tracking-tight text-navy">{`${String(i + 1).padStart(2, "0")}. ${h}`}</h2>
              <p className="mt-4 font-body text-lg leading-relaxed text-slate-600">{b}</p>
            </div>
          ))}
          <p className="border-t border-slate-200 pt-8 font-body text-sm text-slate-400">Last updated: {new Date().toLocaleDateString("en-US", { month: "long", year: "numeric" })}</p>
        </div>
      </section>
      <CTASection
        overline="Let's talk"
        heading={["Ready for a", "senior perspective?"]}
        primary={{ label: "Book Executive Strategy Session", to: "/book" }}
        secondary={{ label: "Contact Aftab", to: "/contact" }}
      />
    </>
  );
}
